"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// from https://stackoverflow.com/a/45355468
var range = function (start, end) {
    return new Array(end - start).fill(null).map(function (_d, i) { return i + start; });
};
exports.default = range;
